import { api } from '../api';
import type { Reservation } from '../reservation/reservationService';

export interface DashboardSummary {
  totalUsers: number;
  totalReservations: number;
  totalAnnouncements: number;
  totalVisitors: number;
  recentActivities: Array<{
    id: string;
    type: string;
    description: string;
    createdAt: string;
  }>;
}

export interface ActiveUserGraph {
  labels: string[];
  data: number[];
}

export interface AccessLogGraph {
  labels: string[];
  data: number[];
}

export interface AccessLog {
  id: string;
  userId: string;
  userName: string;
  action: string;
  timestamp: string;
}

export interface DashboardCounts {
  totalUsers: number;
  totalCompanies: number;
  totalActiveContracts: number;
  totalVisitors: number;
  totalReservations: number;
  totalAnnouncements: number;
  activeUsers: number;
  companies: number;
  equipment: number;
  reservations: number;
  visitors: number;
  pets: number;
  vehicles: number;
}

export interface Visitor {
  id: string;
  name: string;
  document: string;
  hostName: string;
  createdAt: string;
  status: string;
}

export interface DashboardSummaryToday {
  newUsers: number;
  newVisitors: number;
  newReservations: number;
  newAnnouncements: number;
  reservations: Reservation[];
  visitors: Visitor[];
}

export const dashboardService = {
  getSummary: async () => {
    const response = await api.get<DashboardSummary>('/statistics/summary');
    return response.data;
  },

  getActiveUserGraph: async () => {
    const response = await api.get<ActiveUserGraph>('/statistics/active-users');
    return response.data;
  },

  getAccessLogGraph: async () => {
    const response = await api.get<AccessLogGraph>('/statistics/access-logs');
    return response.data;
  },

  getAccessLogs: async () => {
    const response = await api.get<AccessLog[]>('/statistics/access-logs/list');
    return response.data;
  },

  getDashboardCounts: async () => {
    const response = await api.get<DashboardCounts>('/statistics/dashboard-counts');
    return response.data;
  },

  getDashboardSummaryToday: async () => {
    const response = await api.get<DashboardSummaryToday>('/statistics/today');
    return response.data;
  }
}; 